import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { patientTranslationKeys } from '../../translations';
import { PatientUnconfirmedFormBean } from '../patientUnconfirmedUpdate.types';

import { ComparedPatientPreviewCard } from './ComparedPatientPreviewCard';
import { ComparedPatientPreviewInfoItem } from './ComparedPatientPreviewInfoItem';

type ComparedPatientPreviewPersonalDataSectionProps = {
   readonly patient: PatientUnconfirmedFormBean;
   readonly comparedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
   readonly onCopy: (name: string, value: string) => void;
};

export const ComparedPatientPreviewPersonalDataSection = (
   props: ComparedPatientPreviewPersonalDataSectionProps
): JSX.Element => {
   const { comparedPatient } = props;
   const comparedPatientFirstName = comparedPatient.firstName?.asString();
   const comparedPatientMiddleName = comparedPatient.middleName?.asString();
   const comparedPatientLastName = comparedPatient.lastName?.asString();
   return (
      <ComparedPatientPreviewCard appointmentSourceLabel={props.comparedPatient.sourceLabel}>
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.firstName}
            name={'firstName'}
            testId={'comparedPatientFirstName'}
            value={comparedPatientFirstName}
            displayValue={comparedPatientFirstName}
            onCopy={props.onCopy}
            consistent={props.patient.firstName === comparedPatientFirstName}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.middleName}
            name={'middleName'}
            testId={'comparedPatientMiddleName'}
            value={comparedPatientMiddleName}
            displayValue={comparedPatientMiddleName}
            onCopy={props.onCopy}
            consistent={props.patient.middleName === comparedPatientMiddleName}
         />
         <div />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.lastName}
            name={'lastName'}
            testId={'comparedPatientLastName'}
            value={comparedPatientLastName}
            displayValue={comparedPatientLastName}
            onCopy={props.onCopy}
            consistent={props.patient.lastName === comparedPatientLastName}
         />
      </ComparedPatientPreviewCard>
   );
};
